import React, { memo } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function Offer() {
  return <section id="offer-section" className="py-24 bg-heritage-cream bg-paper-texture" data-id="element-87">
      <div className="max-w-5xl mx-auto px-6 content-relative" data-id="element-88">
        <div className="bg-white rounded-3xl shadow-xl border border-heritage-gold/30 overflow-hidden" data-id="element-89">
          <div className="grid md:grid-cols-2" data-id="element-90">
            <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-91">
              <FadeIn data-id="element-92">
                <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-heritage-coffee" data-id="element-93">
                  Asegura la memoria de tu cocina hoy mismo.
                </h2>
                <p className="text-xl text-heritage-coffee/80 mb-8" data-id="element-94">
                  No esperes a que sea demasiado tarde para empezar a escribir.
                </p>

                <div className="mb-8" data-id="element-95">
                  <div className="flex items-center gap-2 mb-3" data-id="element-96">
                    <span className="text-sm uppercase tracking-widest text-heritage-terracotta font-bold" data-id="element-97">
                      Precio Especial de Lanzamiento
                    </span>
                    <span className="text-xs uppercase tracking-wider bg-heritage-terracotta text-white font-bold px-2 py-1 rounded" data-id="element-98">
                      -76% OFF
                    </span>
                  </div>
                  <div className="flex items-baseline gap-3 flex-wrap" data-id="element-99">
                    <span className="text-2xl font-serif text-heritage-coffee/50 line-through decoration-heritage-terracotta decoration-2" data-id="element-100">
                      $27.00
                    </span>
                    <span className="text-5xl font-bold text-heritage-terracotta" data-id="element-101">
                      $6.39
                    </span>
                    <span className="text-xl text-heritage-coffee/60" data-id="element-102">USD</span>
                  </div>
                  <p className="mt-2 text-sm text-heritage-coffee/70 font-serif italic" data-id="element-103">
                    Ahorra $20.61 — solo por tiempo limitado.
                  </p>
                </div>

                <Button className="w-full text-xl py-5" data-id="element-104">
                  ¡QUIERO COMENZAR MI LEGADO AHORA!
                </Button>

                <div className="mt-6 flex items-center justify-center gap-2 text-sm text-heritage-coffee/60 font-serif italic" data-id="element-105">
                  <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-106">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-107" />
                  </svg>
                  Pago seguro y descarga instantánea.
                </div>
              </FadeIn>
            </div>

            <div className="bg-heritage-beige p-8 flex items-center justify-center" data-id="element-108">
              <FadeIn delay={0.2} data-id="element-109">
                <img src="https://cdn.magicpatterns.com/uploads/tfCB9JCYuQx4PP67yJEaPz/LEGADO_DE_SABORES.png" alt="Legado de Sabores eBook" className="w-full max-w-md h-auto rounded-lg shadow-lg transform rotate-2" data-id="element-110" />
              </FadeIn>
            </div>
          </div>
        </div>
      </div>
    </section>;
}